import { IconButton } from '@mui/material'
import { CropIcon } from '$common/icons'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { ImagePreviewTypes } from '$comp/_app/components/chat/components/footer/components/send-field/send-field.type'

export function ImagePreviewButtonBar({
  setImagePreviewMode,
}: {
  setImagePreviewMode: (mode: ImagePreviewTypes) => unknown
}) {
  const isDesktopSize = useIsDesktopSize()
  return (
    <div
      style={{
        backgroundColor: 'black',
        display: 'flex',
        justifyContent: 'center',
        zIndex: 2,
        bottom: 0,
        position: 'absolute',
        width: '100%',

        ...(isDesktopSize && {
          position: 'fixed',
          left: 0,
          right: 0,
        }),
      }}
    >
      {/* <IconButton */}
      {/*  sx={{ width: '64px', height: '64px' }} */}
      {/*  onClick={() => setImagePreviewMode('tune')} */}
      {/* > */}
      {/*  <TuneIcon /> */}
      {/* </IconButton> */}
      <IconButton
        sx={{ width: '64px', height: '64px' }}
        onClick={() => setImagePreviewMode('crop')}
      >
        <CropIcon />
      </IconButton>
    </div>
  )
}
